import { MapPin, Users, ArrowRightLeft } from 'lucide-react';
import { Button } from './Button';
import { DatePicker } from './DatePicker';
import { useState, useEffect } from 'react';

interface SearchSummaryBarProps {
  searchParams?: {
    origen: string;
    destino: string;
    fecha: string;
    pasajeros: string;
  };
  onBackToHome?: () => void;
}

export const SearchSummaryBar = ({ searchParams, onBackToHome }: SearchSummaryBarProps) => {
  const [origen, setOrigen] = useState('Ciudad de México');
  const [destino, setDestino] = useState('Guadalajara');
  const [fecha, setFecha] = useState('2026-01-15');
  const [pasajeros, setPasajeros] = useState('2');

  useEffect(() => {
    if (searchParams) {
      setOrigen(searchParams.origen || 'Ciudad de México');
      setDestino(searchParams.destino || 'Guadalajara');
      setFecha(searchParams.fecha || '2026-01-15');
      setPasajeros(searchParams.pasajeros || '2');
    }
  }, [searchParams]);

  const handleSwap = () => {
    const temp = origen;
    setOrigen(destino);
    setDestino(temp);
  };

  const handleUpdate = () => {
    // In a real app, this would trigger a new search
    if (onBackToHome) {
      onBackToHome();
    }
  };

  return (
    <div className="sticky top-[73px] z-40 bg-white border-b border-[#E5E7EB] shadow-sm">
      <div className="max-w-[1440px] mx-auto px-8 py-4">
        <div className="flex flex-wrap items-center gap-4">
          {/* Origen */}
          <div className="flex items-center gap-2 flex-1 min-w-[200px]">
            <MapPin className="w-5 h-5 text-[#6B7280] flex-shrink-0" />
            <input
              type="text"
              value={origen}
              onChange={(e) => setOrigen(e.target.value)}
              className="flex-1 px-3 py-2 border border-[#E5E7EB] rounded-[14px] focus:outline-none focus:ring-2 focus:ring-[#FF6A2A] focus:border-transparent text-sm"
            />
          </div>

          {/* Swap Button */}
          <button
            onClick={handleSwap}
            className="w-9 h-9 bg-[#F7F8FA] hover:bg-[#FF6A2A] hover:text-white text-[#6B7280] rounded-[14px] flex items-center justify-center transition-all duration-200 border border-[#E5E7EB] flex-shrink-0"
          >
            <ArrowRightLeft className="w-4 h-4" />
          </button>

          {/* Destino */}
          <div className="flex items-center gap-2 flex-1 min-w-[200px]">
            <MapPin className="w-5 h-5 text-[#6B7280] flex-shrink-0" />
            <input
              type="text"
              value={destino}
              onChange={(e) => setDestino(e.target.value)}
              className="flex-1 px-3 py-2 border border-[#E5E7EB] rounded-[14px] focus:outline-none focus:ring-2 focus:ring-[#FF6A2A] focus:border-transparent text-sm"
            />
          </div>

          {/* Fecha */}
          <div className="flex items-center gap-2 min-w-[200px]">
            <DatePicker value={fecha} onChange={setFecha} size="compact" />
          </div>

          {/* Pasajeros */}
          <div className="flex items-center gap-2">
            <Users className="w-5 h-5 text-[#6B7280] flex-shrink-0" />
            <input
              type="number"
              value={pasajeros}
              onChange={(e) => setPasajeros(e.target.value)}
              min="1"
              max="9"
              className="w-16 px-3 py-2 border border-[#E5E7EB] rounded-[14px] focus:outline-none focus:ring-2 focus:ring-[#FF6A2A] focus:border-transparent text-sm text-center"
            />
          </div>

          {/* CTA Button */}
          <Button variant="primary" className="px-6 py-2 text-sm" onClick={handleUpdate}>
            Actualizar búsqueda
          </Button>
        </div>
      </div>
    </div>
  );
};